import getListViewStore from '../store/Store';

// Returns undefined (not false) when no list-view row exists — treat as "not stamped".
export default function getConversationCopilotNeedsReplyFromList(
    conversationId: string
): boolean | undefined {
    const relations = getListViewStore().tableViewConversationRelations;
    for (const relation of relations.values()) {
        if (relation.id === conversationId) {
            return relation.copilotNeedsReply;
        }
    }
    return undefined;
}
